import * as React from "react";
import { Col } from 'reactstrap';
import { useGAToken } from "src/modules/GoogleStatistics/hooks/useGAToken";
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import environmentHelper from "src/share/utils/environmentHelper";
import { IGoogleStatisticView } from "src/modules/GoogleStatistics/GoogleStatistics";
import { GAHeaderStats } from "./components/GAHeaderStats";
import { GAWeeksComparison } from "src/share/components/GoogleAnalitycs/GAWeeksComparison";
import { GACountries } from "src/share/components/GoogleAnalitycs/GACountries";
import { GABrowsers } from "src/share/components/GoogleAnalitycs/GABrowsers";
import { useGoogleInit } from "src/share/hooks/useGoogleInit";
import AlertInsightsStats from "./components/AlertInsightsStats";
import { RoutesModules } from "src/modules/Routing/types";

export interface IGoogleStatisticsProps {
  match: {
    params: {
      alertId: string;
      caseId: string;
    }
  };
}

const GoogleAlertStatistics: React.SFC<IGoogleStatisticsProps> = (props) => {
  const { alertId, caseId } = props.match.params;
  const [view] = React.useState<IGoogleStatisticView>(environmentHelper.getFindGAView());
  const { token } = useGAToken();
  const [ready] = useGoogleInit(token);
  const pagePath = `poster/${caseId}`;
  return (
    <div className="providers">
      {ready &&
        <div className={'stats gstats'}>
          <div className="margin-big-card half-cards row">
            <Col className="col-12 no-padding-left">
              <GAHeaderStats pagePath={pagePath} views={view} />
            </Col>
          </div>
          <AlertInsightsStats
            alertId={alertId}
            pagePath={pagePath}
            views={view}
          />
          <div className="margin-big-card half-cards row">
            <Col className="col-12 no-padding-left">
              <GAWeeksComparison pagePath={pagePath} views={view} />
            </Col>
          </div>
          <div className="margin-big-card half-cards row">
            <Col className="col-md-6 col-12 no-padding-left col">
              <GACountries pagePath={pagePath} views={view} />
            </Col>
            <Col className="col-md-6 col-12 no-padding-left col">
              <GABrowsers pagePath={pagePath} views={view} />
            </Col>
          </div>
        </div>}
    </div>
  )
}

export default SidebarContainer(RoutesModules.ALERTS)(GoogleAlertStatistics);



// WEBPACK FOOTER //
// ./src/modules/Alert/GoogleStatistics/GAAlertStatistics.tsx